// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invest {
  background: linear-gradient(150deg, var(--ink-800) 0%, var(--ink-700) 60%, var(--ink-700) 100%);
  position: relative;
}

.invest__inner {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 56px;
  align-items: center;
}

.invest__inner > * {
  /* Grid items default to min-width: auto, which refuses to shrink below
     their content's intrinsic width (an unbreakable string, a nowrap
     button) and can force the whole track wider than its container on
     narrow screens. */
  min-width: 0;
}

.invest__copy h2 {
  margin-top: 16px;
  color: #fff;
  font-size: clamp(26px, 3.6vw, 36px);
  font-weight: 800;
  max-width: 520px;
}

.invest__copy > p {
  margin-top: 16px;
  color: rgba(255, 255, 255, 0.68);
  font-size: 15px;
  max-width: 540px;
}

.invest__points {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.invest__points div {
  display: flex;
  align-items: center;
  gap: 14px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
}

.invest__points strong {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  color: var(--teal);
}

.invest__card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: var(--radius-xl);
  padding: 38px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.35);
}

.invest__card-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--teal-dark);
}

.invest__card h3 {
  margin-top: 12px;
  font-size: 24px;
  font-weight: 800;
}

.invest__card-role {
  margin-top: 4px;
  font-size: 13px;
  color: var(--text-grey);
}

.invest__contact {
  margin-top: 26px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.invest__contact-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: var(--radius-md);
  background: var(--bg-light);
  border: 1px solid var(--border-soft);
  transition: border-color 0.15s ease, transform 0.15s ease;
}

.invest__contact-row:hover {
  border-color: var(--teal);
  transform: translateX(2px);
}

.invest__contact-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  box-shadow: var(--shadow-sm);
  color: var(--teal-dark);
}

.invest__contact-row div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.invest__contact-row span {
  font-size: 11.5px;
  color: var(--text-mute);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.invest__contact-row strong {
  font-size: 14.5px;
  color: var(--text-dark);
}

.invest__card .btn {
  margin-top: 26px;
}

@media (max-width: 980px) {
  .invest__inner {
    grid-template-columns: 1fr;
  }
  .invest__card {
    padding: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Investment.css"],"names":[],"mappings":"AAAA;EACE,+FAA+F;EAC/F,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;;;sBAGoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,gDAAgD;EAChD,0CAA0C;EAC1C,+BAA+B;EAC/B,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".invest {\n  background: linear-gradient(150deg, var(--ink-800) 0%, var(--ink-700) 60%, var(--ink-700) 100%);\n  position: relative;\n}\n\n.invest__inner {\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  gap: 56px;\n  align-items: center;\n}\n\n.invest__inner > * {\n  /* Grid items default to min-width: auto, which refuses to shrink below\n     their content's intrinsic width (an unbreakable string, a nowrap\n     button) and can force the whole track wider than its container on\n     narrow screens. */\n  min-width: 0;\n}\n\n.invest__copy h2 {\n  margin-top: 16px;\n  color: #fff;\n  font-size: clamp(26px, 3.6vw, 36px);\n  font-weight: 800;\n  max-width: 520px;\n}\n\n.invest__copy > p {\n  margin-top: 16px;\n  color: rgba(255, 255, 255, 0.68);\n  font-size: 15px;\n  max-width: 540px;\n}\n\n.invest__points {\n  margin-top: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.invest__points div {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 14px;\n}\n\n.invest__points strong {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--teal);\n}\n\n.invest__card {\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(var(--glass-blur));\n  -webkit-backdrop-filter: blur(var(--glass-blur));\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: var(--radius-xl);\n  padding: 38px;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.35);\n}\n\n.invest__card-label {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: var(--teal-dark);\n}\n\n.invest__card h3 {\n  margin-top: 12px;\n  font-size: 24px;\n  font-weight: 800;\n}\n\n.invest__card-role {\n  margin-top: 4px;\n  font-size: 13px;\n  color: var(--text-grey);\n}\n\n.invest__contact {\n  margin-top: 26px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.invest__contact-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  border-radius: var(--radius-md);\n  background: var(--bg-light);\n  border: 1px solid var(--border-soft);\n  transition: border-color 0.15s ease, transform 0.15s ease;\n}\n\n.invest__contact-row:hover {\n  border-color: var(--teal);\n  transform: translateX(2px);\n}\n\n.invest__contact-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: var(--shadow-sm);\n  color: var(--teal-dark);\n}\n\n.invest__contact-row div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.invest__contact-row span {\n  font-size: 11.5px;\n  color: var(--text-mute);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.invest__contact-row strong {\n  font-size: 14.5px;\n  color: var(--text-dark);\n}\n\n.invest__card .btn {\n  margin-top: 26px;\n}\n\n@media (max-width: 980px) {\n  .invest__inner {\n    grid-template-columns: 1fr;\n  }\n  .invest__card {\n    padding: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
